import * as Yup from "yup";

export const applicantDataSchema = Yup.object().shape({
  address1: Yup.string(),
  address2: Yup.string(),
  city: Yup.string(),
  email: Yup.string(),
  householdCount: Yup.number(),
  householdNetIncome: Yup.number(),
  primaryPhone: Yup.string(),
  state: Yup.string(),
  zip: Yup.string(),
});
